import DashBoardPlugMain from "./DashBoardPlugMain";

export default DashBoardPlugMain;